import './Selector.less'
import { Selector } from './Selector'

export * from './iSelector'

export default Selector
